import { handleActions, createAction } from 'redux-actions';

export const FETCH_IN_REALIZATION = createAction('FETCH/IN_REALIZATION');
export const FETCH_IN_REALIZATION_SUCCESS = createAction('FETCH/IN_REALIZATION/SUCCESS');
export const FETCH_IN_REALIZATION_FAIL = createAction('FETCH/IN_REALIZATION/FAIL');

const initialState = {
  inRealizationErrors: null,
  total_pages: null,
  total_count: null,
  recent_new_bets: null,
  recent_lost_bets: null,
  bets: null,
};

const inRealizationReducer = handleActions(
  {
    [FETCH_IN_REALIZATION_SUCCESS]: (state, { payload, }) => {
      return { ...state, ...payload, };
    },
    [FETCH_IN_REALIZATION_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, inRealizationErrors: error, };
    },
  },
  initialState
);

export default inRealizationReducer;
